var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1992 74.48C99.2831 67.6566 100.608 60.1691 100.051 52.7019C99.4954 45.2346 97.0765 38.0259 93.0159 31.7346C88.9553 25.4433 83.3826 20.2701 76.8071 16.688C70.2316 13.1058 62.8631 11.229 55.3752 11.229C47.8873 11.229 40.5188 13.1058 33.9433 16.688C27.3678 20.2701 21.7951 25.4433 17.7345 31.7346C13.6739 38.0259 11.255 45.2346 10.6989 52.7019C10.1428 60.1691 11.4673 67.6566 14.5512 74.48H96.1992Z",
    fill: "#ECF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6973 74.48H99.0573",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 74.48H11.8",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.297 74.48H104.097",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5601 74.3568H10.7803V36.5512L50.0564 14.0482C50.2437 13.94 50.4562 13.8831 50.6724 13.8831C50.8887 13.8831 51.1011 13.94 51.2884 14.0482L90.5601 36.5512V74.3568Z",
    fill: "white",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6699 13.8846V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.373 21.3147V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0215 17.5056V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7246 25.1238V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0762 28.933V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4277 32.7421V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9668 21.3147V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3184 17.5056V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6152 25.1238V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2637 28.933V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9111 32.7421V74.3568",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5799 40.5742L51.2836 14.0482C51.0963 13.94 50.8839 13.8831 50.6676 13.8831C50.4513 13.8831 50.2389 13.94 50.0516 14.0482L3.75977 40.5742",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7803 52.5594H90.559V74.3557H10.7803V52.5594Z",
    fill: "#ECF2F2",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4638 74.3568H33.8115V44.1504C33.8115 43.8236 33.9413 43.5103 34.1724 43.2792C34.4034 43.0482 34.7168 42.9184 35.0435 42.9184H71.2318C71.5586 42.9184 71.8719 43.0482 72.103 43.2792C72.334 43.5103 72.4638 43.8236 72.4638 44.1504V74.3568Z",
    fill: "#ECF2F2",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8115 54.7064H72.4661V74.3568H33.8115V54.7064Z",
    fill: "white",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9838 69.4232C39.9838 69.0964 39.854 68.7831 39.623 68.552C39.392 68.321 39.0786 68.1912 38.7518 68.1912H33.8115V74.3568H39.9838V69.4232Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8077 63.2553C37.8077 62.9286 37.6779 62.6152 37.4468 62.3842C37.2158 62.1531 36.9024 62.0233 36.5757 62.0233H33.8115V68.1923H37.8077V63.2553Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9912 46.8451H72.4677",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9912 50.7763H72.4677",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7732 61.9427C26.7732 61.616 26.6434 61.3026 26.4124 61.0716C26.1813 60.8405 25.868 60.7107 25.5412 60.7107H17.4459C17.1191 60.7107 16.8058 60.8405 16.5747 61.0716C16.3437 61.3026 16.2139 61.616 16.2139 61.9427V74.3568H26.7766L26.7732 61.9427Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5596 63.1456H24.4261V67.4117H18.5596V63.1456Z",
    fill: "#ECF2F2",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5938 23.3587H59.7456V36.6934H41.5938V23.3587Z",
    fill: "#ECF2F2",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1221 87.4955C63.1221 87.9738 64.9966 88.4324 68.3333 88.7706C71.67 89.1087 76.1956 89.2987 80.9144 89.2987C85.6332 89.2987 90.1587 89.1087 93.4955 88.7706C96.8322 88.4324 98.7067 87.9738 98.7067 87.4955C98.7067 87.0173 96.8322 86.5586 93.4955 86.2205C90.1587 85.8823 85.6332 85.6923 80.9144 85.6923C76.1956 85.6923 71.67 85.8823 68.3333 86.2205C64.9966 86.5586 63.1221 87.0173 63.1221 87.4955Z",
    fill: "#ECF2F2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9043 87.4955C36.9043 87.9738 37.9645 88.4324 39.8517 88.7706C41.739 89.1087 44.2986 89.2987 46.9675 89.2987C49.6364 89.2987 52.196 89.1087 54.0833 88.7706C55.9705 88.4324 57.0307 87.9738 57.0307 87.4955C57.0307 87.0173 55.9705 86.5586 54.0833 86.2205C52.196 85.8823 49.6364 85.6923 46.9675 85.6923C44.2986 85.6923 41.739 85.8823 39.8517 86.2205C37.9645 86.5586 36.9043 87.0173 36.9043 87.4955Z",
    fill: "#ECF2F2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.447 82.6168H93.1836V61.1049H101.068C102.969 61.1049 104.793 61.8602 106.137 63.2044C107.481 64.5487 108.236 66.3719 108.236 68.273V80.8169C108.237 81.0527 108.192 81.2864 108.102 81.5046C108.013 81.7228 107.881 81.9212 107.715 82.0884C107.549 82.2556 107.351 82.3883 107.134 82.479C106.916 82.5697 106.682 82.6165 106.447 82.6168Z",
    fill: "white",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9131 80.8237C60.9131 81.299 61.1019 81.7548 61.4379 82.0908C61.774 82.4269 62.2298 82.6157 62.7051 82.6157H93.1836V58.595C93.1836 58.1198 92.9948 57.664 92.6588 57.3279C92.3227 56.9918 91.8669 56.803 91.3916 56.803H62.7051C62.2298 56.803 61.774 56.9918 61.4379 57.3279C61.1019 57.664 60.9131 58.1198 60.9131 58.595V80.8237Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9131 80.8237C60.9131 81.299 61.1019 81.7548 61.4379 82.0908C61.774 82.4269 62.2298 82.6157 62.7051 82.6157H93.1836V58.595C93.1836 58.1198 92.9948 57.664 92.6588 57.3279C92.3227 56.9918 91.8669 56.803 91.3916 56.803H62.7051C62.2298 56.803 61.774 56.9918 61.4379 57.3279C61.1019 57.664 60.9131 58.1198 60.9131 58.595V80.8237Z",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9131 80.8237C60.9131 81.2989 61.1019 81.7547 61.4379 82.0908C61.774 82.4269 62.2298 82.6157 62.7051 82.6157H93.1836V78.3149H60.9131V80.8237Z",
    fill: "#ECF2F2",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2148 82.6168C65.2146 83.4679 65.4668 84.3 65.9395 85.0078C66.4122 85.7155 67.0841 86.2672 67.8704 86.5931C68.6567 86.919 69.5219 87.0043 70.3567 86.8384C71.1915 86.6725 71.9583 86.2628 72.5602 85.661C73.1621 85.0593 73.572 84.2926 73.7382 83.4578C73.9043 82.6231 73.8191 81.7578 73.4935 80.9715C73.1678 80.1851 72.6163 79.513 71.9086 79.0401C71.201 78.5673 70.369 78.3149 69.5179 78.3149C68.3768 78.3149 67.2825 78.7681 66.4756 79.5748C65.6686 80.3815 65.2151 81.4758 65.2148 82.6168Z",
    fill: "#ECF2F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8789 82.6168C88.8787 83.4678 89.1308 84.2998 89.6034 85.0075C90.076 85.7152 90.7478 86.267 91.534 86.5929C92.3201 86.9188 93.1852 87.0043 94.0199 86.8386C94.8546 86.6729 95.6215 86.2633 96.2235 85.6618C96.8255 85.0603 97.2356 84.2938 97.402 83.4592C97.5683 82.6246 97.4835 81.7594 97.1582 80.973C96.8329 80.1866 96.2817 79.5144 95.5743 79.0412C94.867 78.5681 94.0352 78.3153 93.1842 78.3149C92.619 78.3146 92.0593 78.4256 91.5371 78.6417C91.0148 78.8577 90.5402 79.1745 90.1404 79.574C89.7406 79.9735 89.4234 80.4478 89.207 80.9699C88.9905 81.492 88.8791 82.0516 88.8789 82.6168Z",
    fill: "#ECF2F2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2148 82.6168C65.2146 83.4679 65.4668 84.3 65.9395 85.0078C66.4122 85.7155 67.0841 86.2672 67.8704 86.5931C68.6567 86.919 69.5219 87.0043 70.3567 86.8384C71.1915 86.6725 71.9583 86.2628 72.5602 85.661C73.1621 85.0593 73.572 84.2926 73.7382 83.4578C73.9043 82.6231 73.8191 81.7578 73.4935 80.9715C73.1678 80.1851 72.6163 79.513 71.9086 79.0401C71.201 78.5673 70.369 78.3149 69.5179 78.3149C68.3768 78.3149 67.2825 78.7681 66.4756 79.5748C65.6686 80.3815 65.2151 81.4758 65.2148 82.6168V82.6168Z",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8789 82.6168C88.8787 83.4678 89.1308 84.2998 89.6034 85.0075C90.076 85.7152 90.7478 86.267 91.534 86.5929C92.3201 86.9188 93.1852 87.0043 94.0199 86.8386C94.8546 86.6729 95.6215 86.2633 96.2235 85.6618C96.8255 85.0603 97.2356 84.2938 97.402 83.4592C97.5683 82.6246 97.4835 81.7594 97.1582 80.973C96.8329 80.1866 96.2817 79.5144 95.5743 79.0412C94.867 78.5681 94.0352 78.3153 93.1842 78.3149C92.619 78.3146 92.0593 78.4256 91.5371 78.6417C91.0148 78.8577 90.5402 79.1745 90.1404 79.574C89.7406 79.9735 89.4234 80.4478 89.207 80.9699C88.9905 81.492 88.8791 82.0516 88.8789 82.6168V82.6168Z",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.936 70.6261C103.936 70.9528 103.806 71.2662 103.575 71.4972C103.344 71.7283 103.031 71.8581 102.704 71.8581H98.7193C98.3926 71.8581 98.0792 71.7283 97.8481 71.4972C97.6171 71.2662 97.4873 70.9528 97.4873 70.6261V66.64C97.4873 66.3132 97.6171 65.9999 97.8481 65.7688C98.0792 65.5378 98.3926 65.408 98.7193 65.408H100.352C101.303 65.408 102.214 65.7856 102.887 66.4577C103.559 67.1298 103.936 68.0414 103.936 68.992V70.6261Z",
    fill: "#ECF2F2",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M103.936 82.6168H106.444C106.92 82.6168 107.375 82.428 107.711 82.0919C108.048 81.7559 108.236 81.3001 108.236 80.8248V77.2408H105.168C104.841 77.2408 104.527 77.3706 104.296 77.6016C104.065 77.8327 103.936 78.146 103.936 78.4728V82.6168Z",
    fill: "#ECF2F2",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6481 78.4739C56.6481 78.1472 56.5183 77.8338 56.2872 77.6028C56.0562 77.3717 55.7428 77.2419 55.4161 77.2419H46.9668V86.9232H55.4127C55.7395 86.9232 56.0528 86.7934 56.2839 86.5624C56.5149 86.3313 56.6447 86.018 56.6447 85.6912L56.6481 78.4739Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9671 77.2386H38.5201C38.1933 77.2386 37.88 77.3684 37.6489 77.5994C37.4179 77.8304 37.2881 78.1438 37.2881 78.4706V85.68C37.2881 86.0068 37.4179 86.3201 37.6489 86.5512C37.88 86.7822 38.1933 86.912 38.5201 86.912H46.9671V77.2386Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0878 68.7926C53.0878 68.6309 53.0559 68.4706 52.994 68.3212C52.9321 68.1717 52.8413 68.0359 52.7269 67.9215C52.6125 67.8071 52.4767 67.7163 52.3273 67.6544C52.1778 67.5925 52.0176 67.5606 51.8558 67.5606H44.6441C44.4823 67.5606 44.3221 67.5925 44.1726 67.6544C44.0232 67.7163 43.8874 67.8071 43.773 67.9215C43.6586 68.0359 43.5678 68.1717 43.5059 68.3212C43.444 68.4706 43.4121 68.6309 43.4121 68.7926V77.2386H53.0878V68.7926Z",
    fill: "#FFC341",
    stroke: "#006E4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.4ab2f6620ba8bb8908e3c9eeb23991f4.svg";
export { ForwardRef as ReactComponent };